import { Component, Vue } from 'vue-property-decorator';
import SettingService from '@/modules/services/setting.service';

const settingService = new SettingService();

@Component
export default class gmailAuth extends Vue {
    public last_updated : any = ''
    public last_updated_user : any = ''
    public successMessage : any = ''
    public created() {
        console.log("Loadedddddd")
        this.mfaAuthentication();
    }
    private mfaAuthentication() {
        this.$store.state.Loading = true;
		settingService.GetGmailAuth().then((res: any) => {
			this.$store.state.Loading = false;
			const response = res.data.data;
			console.log(response)
			if (response) {
                this.last_updated = response.content.last_update;
                this.last_updated_user = response.content.last_updated_user;
			}
		}, (err: any) => {
			this.$store.state.Loading = false;
		});
    }

    private GmailAuthSubmit() {
        const form: any = document.getElementById('GmailAuthSubmit');
        const formData = new FormData(form);
        console.log("FORM -" + formData)
        settingService.GmailAuth(formData).then((response: any) => {
            this.successMessage = response.data.data.message
            if (response.data.data.status === true) {
                setTimeout(() => {
                    this.mfaAuthentication();
                    this.$store.dispatch('showSuccessMsg', this.successMessage);
                    console.log("Gmail auth updated successfully")
                }, 200);
            } else {
                this.$store.dispatch('showErrorMsg', this.successMessage);
                console.log("Error in Gmail Auth updation")
            }
        }, (err: any) => {
            this.$store.dispatch('showErrorMsg', err.message);
        });
    }

}